import { DashMenuIcon } from "model/Datatypes";
import React from "react";

interface Props {
  type: DashMenuIcon;
  className?: string;
  fill?: string;
  cy?: number;
  cx?: number;
}

const Icon = ({ type, className, fill, cy, cx }: Props) => {
  const noData = (
    <svg
      width="100%"
      height="100%"
      cy={cy}
      cx={cx}
      viewBox="0 0 1875 1875"
      className={className}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M937.5 388.045C634.045 388.045 388.045 634.045 388.045 937.5C388.045 1240.96 634.045 1486.95 937.5 1486.95C1240.96 1486.95 1486.95 1240.96 1486.95 937.5C1486.95 634.045 1240.96 388.045 937.5 388.045ZM182 937.5C182 520.249 520.249 182 937.5 182C1354.75 182 1693 520.249 1693 937.5C1693 1354.75 1354.75 1693 937.5 1693C520.249 1693 182 1354.75 182 937.5Z"
        fill="#D1D1D1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1299.53 1449.29L376.968 526.727L526.727 376.968L1449.29 1299.53L1299.53 1449.29Z"
        fill="#D1D1D1"
      />
    </svg>
  );

  const coolingIcon = (
    <svg
      className={className}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 36.566 29.738"
    >
      <defs>
        <filter
          id="Line_98"
          width="36.566"
          height="29.738"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#2f7bd2" floodOpacity="0.302"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="Group 136" transform="translate(9.787 5.539)">
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.758"
          d="M0 0L0 18.666"
          data-name="Line 93"
          transform="translate(8.496)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M2.748 0L0 2.166"
          data-name="Line 94"
          transform="translate(8.496 1.11)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 0L2.748 2.166"
          data-name="Line 95"
          transform="translate(5.748 1.11)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 2.172L2.748 0"
          data-name="Line 96"
          transform="translate(5.748 15.636)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M2.748 2.172L0 0"
          data-name="Line 97"
          transform="translate(8.496 15.636)"
        ></path>
        <g filter="url(#Line_98)" transform="translate(-9.79 -5.54)">
          <path
            fill="none"
            stroke="#4ea6ff"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.758"
            d="M0 0L16.164 9.336"
            data-name="Line 98"
            transform="translate(10.2 10.2)"
          ></path>
        </g>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 0L0.504 3.468"
          data-name="Line 99"
          transform="translate(2.748 2.838)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 1.296L3.252 0"
          data-name="Line 100"
          transform="translate(0 6.306)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0.504 3.462L0 0"
          data-name="Line 101"
          transform="translate(13.956 12.486)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M3.252 0L0 1.296"
          data-name="Line 102"
          transform="translate(13.956 11.19)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.758"
          d="M0 9.336L16.164 0"
          data-name="Line 103"
          transform="translate(.414 4.788)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 0L3.252 1.296"
          data-name="Line 104"
          transform="translate(0 11.19)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0 3.462L0.504 0"
          data-name="Line 105"
          transform="translate(2.748 12.486)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M3.252 1.296L0 0"
          data-name="Line 106"
          transform="translate(13.956 6.306)"
        ></path>
        <path
          fill="none"
          stroke="#4ea6ff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.32"
          d="M0.504 0L0 3.468"
          data-name="Line 107"
          transform="translate(13.956 2.838)"
        ></path>
      </g>
    </svg>
  );

  const hotwaterIcon = (
    <svg
      className={className}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 20.796 22.142"
    >
      <g data-name="Group 133" transform="translate(.681)">
        <path
          fill="#fff"
          d="M39.718 29.512a4.934 4.934 0 00-3.528-1.47H22.084v1.734h14.088c.87 0 0 .2.642.816s1.2-.45 1.2.42v2.6h1.74v-2.6c.03-1.32.9-.558-.036-1.5z"
          data-name="Path 737"
          transform="translate(-22.084 -21.484)"
        ></path>
        <path
          fill="none"
          stroke="#ff5f45"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M15.54 14.952a2.094 2.094 0 00-.81 1.4c0 1.122.8 2.082.774 3s-.294.984-.774 1.572"
          data-name="Path 738"
        ></path>
        <path
          fill="none"
          stroke="#ff5f45"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M18.9 14.952a2.093 2.093 0 00-.81 1.4c0 1.122.8 2.082.78 3s-.3.984-.78 1.572"
          data-name="Path 739"
        ></path>
        <path
          fill="#161616"
          d="M40.072 28.1a4.943 4.943 0 00-3.534-1.47H22.432v1.746h14.094a3.228 3.228 0 013.24 3.216v2.634h1.74v-2.6a4.931 4.931 0 00-1.434-3.526z"
          data-name="Path 740"
          transform="translate(-22.084 -21.484)"
        ></path>
        <path
          fill="#161616"
          d="M38.452 34.216v-2.61a1.913 1.913 0 00-.534-1.374 1.945 1.945 0 00-1.38-.57H22.432v1.716h14.106a.206.206 0 01.156.06.192.192 0 01.054.138V34.2z"
          data-name="Path 741"
          transform="translate(-22.084 -21.484)"
        ></path>
        <path
          fill="#161616"
          d="M0 0H2.16V1.722H0z"
          data-name="Rectangle 2463"
          transform="translate(15.732 11.01)"
        ></path>
        <path
          fill="none"
          stroke="#161616"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M0 0L0 17.052"
          data-name="Line 108"
          transform="translate(.186)"
        ></path>
        <path
          fill="none"
          stroke="#161616"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M0 4.164L0 0"
          data-name="Line 109"
          transform="translate(9.552 1.158)"
        ></path>
        <path
          fill="none"
          stroke="#161616"
          strokeMiterlimit="10"
          strokeWidth="1.734"
          d="M0 0L6.654 0"
          data-name="Line 110"
          transform="translate(6.21 .87)"
        ></path>
      </g>
    </svg>
  );

  const building = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="" />
      <path d="M69.5 381H379.5" stroke="black" strokeWidth="10" />
      <path d="M354.5 376V131H256.5V376" stroke="black" strokeWidth="10" />
      <path d="M256.5 126V68.5H95V377.5" stroke="black" strokeWidth="10" />
      <path d="M190 376V284.5H228.5V376" stroke="black" strokeWidth="10" />
      <path d="M125 322.5V284H164V322.5H125Z" stroke="black" strokeWidth="10" />
      <path d="M125 258.5V220H164V258.5H125Z" stroke="black" strokeWidth="10" />
      <path d="M189 258.5V220H228V258.5H189Z" stroke="black" strokeWidth="10" />
      <path d="M286 322.5V284H325V322.5H286Z" stroke="black" strokeWidth="10" />
      <path d="M286 258.5V220H325V258.5H286Z" stroke="black" strokeWidth="10" />
      <path d="M286 194.5V156H325V194.5H286Z" stroke="black" strokeWidth="10" />
      <path d="M189 194.5V156H228V194.5H189Z" stroke="black" strokeWidth="10" />
      <path d="M125 194.5V156H164V194.5H125Z" stroke="black" strokeWidth="10" />
      <path d="M125 130.5V92H164V130.5H125Z" stroke="black" strokeWidth="10" />
      <path d="M189 130.5V92H228V130.5H189Z" stroke="black" strokeWidth="10" />
    </svg>
  );

  const contact = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="" />
      <path
        d="M72 97V344.706C72 348.491 76.7692 350.159 79.1281 347.199L145.073 264.453C145.832 263.501 146.984 262.946 148.201 262.946H375C377.209 262.946 379 261.156 379 258.946V97C379 94.7909 377.209 93 375 93H76C73.7909 93 72 94.7909 72 97Z"
        stroke="#373737"
        strokeWidth="12"
      />
      <path d="M225.5 158.786V224.572" stroke="#373737" strokeWidth="18" />
      <circle cx="225" cy="136" r="10" fill="#373737" />
    </svg>
  );

  const energyCentral = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="" />
      <g>
        <path
          d="M101.5 223.901V160.741C101.5 159.664 102.077 158.67 103.012 158.136L160.012 125.565C162.012 124.422 164.5 125.866 164.5 128.17V192.235C164.5 193.324 163.909 194.328 162.957 194.857L105.957 226.524C103.957 227.635 101.5 226.189 101.5 223.901Z"
          fill="#5B5B5B"
          stroke="black"
          strokeWidth="10"
        />
        <path
          d="M104.342 227.057L103.524 228.034C102.575 229.166 100.944 229.439 99.6786 228.679L58.4544 203.897C57.552 203.355 57 202.379 57 201.326V140.003C57 138.935 57.5683 137.947 58.492 137.41L119.602 101.877C120.534 101.335 121.685 101.335 122.617 101.876L165 126.506"
          stroke="black"
          strokeWidth="10"
        />
        <path
          d="M160 198.197V264.33C160 266.634 162.488 268.078 164.488 266.935L259.988 212.364C260.923 211.83 261.5 210.836 261.5 209.759V140.803C261.5 138.47 258.954 137.03 256.955 138.232L161.455 195.626C160.552 196.168 160 197.144 160 198.197Z"
          fill="#5B5B5B"
          stroke="black"
          strokeWidth="10"
        />
        <path
          d="M117.448 243.46L159.209 268.71C159.523 268.9 159.883 269 160.249 269C161.359 269 162.259 268.1 162.259 266.99V197.956C162.259 196.889 162.825 195.903 163.746 195.365L258.6 139.99C260.575 138.837 260.586 135.988 258.62 134.82L223.394 113.898C222.46 113.344 221.299 113.337 220.359 113.882L117.497 173.437C116.57 173.973 116 174.963 116 176.033V240.893C116 241.943 116.549 242.917 117.448 243.46Z"
          fill="white"
          stroke="black"
          strokeWidth="10"
        />
        <path
          d="M227 237.197V303.33C227 305.634 229.488 307.078 231.488 305.935L326.988 251.364C327.923 250.83 328.5 249.836 328.5 248.759V179.803C328.5 177.47 325.954 176.03 323.955 177.232L228.455 234.626C227.552 235.168 227 236.144 227 237.197Z"
          fill="#5B5B5B"
          stroke="black"
          strokeWidth="10"
        />
        <path
          d="M184.448 282.46L226.209 307.71C226.523 307.9 226.883 308 227.249 308C228.359 308 229.259 307.1 229.259 305.99V236.956C229.259 235.889 229.825 234.903 230.746 234.365L325.6 178.99C327.575 177.837 327.586 174.988 325.62 173.82L290.394 152.898C289.46 152.344 288.299 152.337 287.359 152.882L184.497 212.437C183.57 212.973 183 213.963 183 215.033V279.893C183 280.943 183.549 281.917 184.448 282.46Z"
          fill="white"
          stroke="black"
          strokeWidth="10"
        />
        <path
          d="M290 275.631V344.054C290 345.589 291.659 346.552 292.992 345.79L390.492 290.076C391.115 289.72 391.5 289.057 391.5 288.339V217.035C391.5 215.48 389.803 214.52 388.47 215.321L290.97 273.917C290.368 274.279 290 274.929 290 275.631Z"
          fill="#5B5B5B"
          stroke="black"
          strokeWidth="10"
        />
        <path
          d="M247.448 321.46L289.209 346.71C289.523 346.9 289.883 347 290.249 347C291.359 347 292.259 346.1 292.259 344.99V275.956C292.259 274.889 292.825 273.903 293.746 273.365L388.6 217.99C390.575 216.837 390.586 213.988 388.62 212.82L353.394 191.898C352.46 191.344 351.299 191.337 350.359 191.882L247.497 251.437C246.57 251.973 246 252.963 246 254.033V318.893C246 319.943 246.549 320.917 247.448 321.46Z"
          fill="white"
          stroke="black"
          strokeWidth="10"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="32"
          y="77.47"
          width="384.5"
          height="295.53"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );

  const energySystem = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="none" />
      <path
        d="M51 303.241H148.928M398 303.241H300.072M148.928 303.241V141.707H242.448H300.072V152.098V303.241M148.928 303.241H300.072"
        stroke="black"
        strokeWidth="12"
      />
      <path d="M146.725 207.518H80.9142V237.431" stroke="black" strokeWidth="12" />
      <path d="M215.524 135.861V69.7792" stroke="black" strokeWidth="12" />
      <path d="M302.275 171.62H368.085V135.724" stroke="black" strokeWidth="12" />
      <path d="M302.275 267.344H344.154" stroke="black" strokeWidth="12" />
      <path d="M248.43 303.242V351.104H272.361V381.017" stroke="black" strokeWidth="12" />
      <path d="M176.637 303.242V363.069" stroke="black" strokeWidth="12" />
      <circle cx="212.534" cy="63.931" r="17.931" fill="white" />
      <circle cx="212.534" cy="63.931" r="17.931" fill="url(#paint0_linear)" />
      <circle cx="212.534" cy="63.931" r="17.931" stroke="black" strokeWidth="12" />
      <circle cx="368.086" cy="135.724" r="17.931" fill="white" />
      <circle cx="368.086" cy="135.724" r="17.931" fill="url(#paint1_linear)" />
      <circle cx="368.086" cy="135.724" r="17.931" stroke="black" strokeWidth="12" />
      <circle cx="344.156" cy="267.345" r="17.931" fill="white" />
      <circle cx="344.156" cy="267.345" r="17.931" fill="url(#paint2_linear)" />
      <circle cx="344.156" cy="267.345" r="17.931" stroke="black" strokeWidth="12" />
      <circle cx="272.361" cy="387" r="17.931" fill="white" />
      <circle cx="272.361" cy="387" r="17.931" fill="url(#paint3_linear)" />
      <circle cx="272.361" cy="387" r="17.931" stroke="black" strokeWidth="12" />
      <circle cx="176.639" cy="363.069" r="17.931" fill="white" />
      <circle cx="176.639" cy="363.069" r="17.931" fill="url(#paint4_linear)" />
      <circle cx="176.639" cy="363.069" r="17.931" stroke="black" strokeWidth="12" />
      <circle cx="80.9125" cy="243.413" r="17.931" fill="white" />
      <circle cx="80.9125" cy="243.413" r="17.931" fill="url(#paint5_linear)" />
      <circle cx="80.9125" cy="243.413" r="17.931" stroke="black" strokeWidth="12" />
      <path
        d="M205 230.652V264.5C205 264.944 205.481 265.221 205.865 264.998L254.003 237.078C254.62 236.72 255 236.061 255 235.348V203.972C255 202.431 253.33 201.469 251.997 202.242L205.997 228.922C205.38 229.28 205 229.939 205 230.652Z"
        fill="#5B5B5B"
        stroke="black"
        strokeWidth="4"
      />
      <path
        d="M205.144 265L185.966 253.423C185.367 253.061 185 252.412 185 251.711V219.523C185 218.819 185.371 218.166 185.977 217.805L233.314 189.618C233.953 189.238 234.749 189.243 235.383 189.632L254.046 201.081C254.639 201.445 255 202.091 255 202.786V208.76"
        stroke="black"
        strokeWidth="4"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="212.534"
          y1="40"
          x2="212.534"
          y2="87.8621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="368.086"
          y1="111.793"
          x2="368.086"
          y2="159.655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="344.156"
          y1="243.414"
          x2="344.156"
          y2="291.276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="272.361"
          y1="363.069"
          x2="272.361"
          y2="410.931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="176.639"
          y1="339.138"
          x2="176.639"
          y2="387"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1="80.9125"
          y1="219.482"
          x2="80.9125"
          y2="267.344"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );

  const heatPump = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="" />
      <g>
        <path
          d="M167.143 236.67V368.214C167.143 369.927 168.998 370.995 170.48 370.136L357.011 261.948C358.861 260.875 360 258.897 360 256.758V131.773C360 127.149 354.99 124.263 350.99 126.583L170.133 231.48C168.282 232.554 167.143 234.531 167.143 236.67Z"
          fill="#5B5B5B"
          stroke="black"
          strokeWidth="14"
        />
        <path
          d="M167.698 370.143L92.8992 324.99C91.0998 323.904 90 321.955 90 319.853V193.759C90 191.644 91.1133 189.686 92.9303 188.604L277.244 78.8554C279.16 77.7146 281.55 77.7303 283.451 78.8964L357.137 124.101C358.916 125.192 360 127.129 360 129.215V153.217"
          stroke="black"
          strokeWidth="14"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="63"
          y="52.0107"
          width="324"
          height="346.439"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );

  const pylons = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="none" />
      <path
        d="M156.232 107.798V311.871C156.808 322.669 153.097 333.258 145.907 341.334C138.717 349.411 128.629 354.322 117.837 355C107.059 354.323 96.988 349.406 89.8258 341.324C82.6636 333.241 78.9931 322.652 79.6168 311.871V107.798"
        fill="#3C3C3C"
      />
      <path
        d="M261.424 107.798V311.871C262 322.669 258.289 333.258 251.099 341.334C243.909 349.411 233.821 354.322 223.029 355C212.251 354.323 202.18 349.406 195.018 341.324C187.856 333.241 184.185 322.652 184.809 311.871V107.798"
        fill="#3C3C3C"
      />
      <path
        d="M366.616 107.798V311.871C367.251 317.279 366.734 322.759 365.098 327.953C363.463 333.146 360.747 337.934 357.128 342.002C353.509 346.07 349.071 349.326 344.103 351.556C339.136 353.785 333.753 354.938 328.309 354.938C322.864 354.938 317.481 353.785 312.514 351.556C307.547 349.326 303.108 346.07 299.489 342.002C295.871 337.934 293.154 333.146 291.519 327.953C289.884 322.759 289.366 317.279 290.001 311.871V107.798"
        fill="#3C3C3C"
      />
      <path
        d="M117.836 326.248C114.239 326.022 110.876 324.385 108.479 321.692C106.083 319 104.846 315.471 105.038 311.871V107.798C105.038 104.404 106.386 101.149 108.786 98.7486C111.186 96.3484 114.442 95 117.836 95C121.23 95 124.486 96.3484 126.886 98.7486C129.286 101.149 130.635 104.404 130.635 107.798V311.871C130.826 315.471 129.59 319 127.193 321.692C124.796 324.385 121.433 326.022 117.836 326.248Z"
        fill="white"
      />
      <path
        d="M223.028 326.248C219.431 326.022 216.068 324.385 213.672 321.692C211.275 319 210.038 315.471 210.23 311.871V107.798C210.23 104.404 211.578 101.149 213.979 98.7486C216.379 96.3484 219.634 95 223.028 95C226.423 95 229.678 96.3484 232.078 98.7486C234.478 101.149 235.827 104.404 235.827 107.798V311.871C236.019 315.471 234.782 319 232.385 321.692C229.988 324.385 226.626 326.022 223.028 326.248Z"
        fill="white"
      />
      <path
        d="M328.221 326.248C324.623 326.022 321.261 324.385 318.864 321.692C316.467 319 315.23 315.471 315.422 311.871V107.798C315.422 104.404 316.771 101.149 319.171 98.7486C321.571 96.3484 324.826 95 328.221 95C331.615 95 334.87 96.3484 337.27 98.7486C339.671 101.149 341.019 104.404 341.019 107.798V311.871C341.211 315.471 339.974 319 337.577 321.692C335.181 324.385 331.818 326.022 328.221 326.248Z"
        fill="white"
      />
      <path d="M392.914 95.3507H57V129.889H392.914V95.3507Z" fill="#3C3C3C" />
    </svg>
  );

  const seasonalVariation = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="none" />
      <mask id="path-1-inside-1" fill="white">
        <path d="M293.92 161.396C277.106 144.647 254.318 135.255 230.572 135.287C206.825 135.32 184.063 144.773 167.294 161.569C150.526 178.364 141.123 201.126 141.156 224.846C141.188 248.566 150.653 271.302 167.467 288.052" />
      </mask>
      <path
        d="M281.217 174.149C288.26 181.165 299.657 181.143 306.673 174.1C313.689 167.057 313.667 155.66 306.624 148.644L281.217 174.149ZM154.764 300.804C161.807 307.82 173.204 307.798 180.22 300.755C187.236 293.712 187.214 282.315 180.171 275.299L154.764 300.804ZM306.624 148.644C286.427 128.525 259.061 117.248 230.547 117.287L230.596 153.287C249.576 153.261 267.784 160.768 281.217 174.149L306.624 148.644ZM230.547 117.287C202.033 117.326 174.698 128.678 154.556 148.851L180.033 174.287C193.429 160.869 211.617 153.313 230.596 153.287L230.547 117.287ZM154.556 148.851C134.414 169.025 123.117 196.37 123.156 224.871L159.156 224.821C159.13 205.882 166.637 187.704 180.033 174.287L154.556 148.851ZM123.156 224.871C123.195 253.371 134.567 280.685 154.764 300.804L180.171 275.299C166.739 261.919 159.182 243.761 159.156 224.821L123.156 224.871Z"
        fill="#3C3C3C"
        mask="url(#path-1-inside-1)"
      />
      <path
        d="M236.631 78V105.735"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M70 230.765H102.963"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M116.226 110.358L141.154 135.287"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M333.483 114.98L313.014 135.287"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M116.226 332.239L141.154 307.147"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M351.362 203.352L208.808 343.437"
        stroke="#3C3C3C"
        strokeWidth="18"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M366.135 235.342L326.344 227.939"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M319.64 188.027L326.347 227.941"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M192.118 313.339L231.954 320.698"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M238.613 360.655L231.952 320.695"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M301.541 372L281.165 275.3"
        stroke="#3C3C3C"
        strokeWidth="18"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M266.389 369.523L292.055 338.228"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M330.261 351.594L292.057 338.231"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M379.082 296.979L281.166 275.3"
        stroke="#3C3C3C"
        strokeWidth="18"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M361.531 327.532L344.553 290.791"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M373.23 262.234L344.551 290.793"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );

  const solarPanels = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="none" />
      <path
        d="M63 186.043H78.3804"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M93.7609 93.7608L109.141 109.141"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M186.043 63V78.3677"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M262.945 93.7608L247.565 109.141"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <mask id="path-5-inside-1" fill="white">
        <path d="M232.185 130.171C218.641 116.68 200.288 109.115 181.161 109.141C162.034 109.167 143.701 116.782 130.195 130.31C116.688 143.838 109.115 162.171 109.141 181.276C109.167 200.381 116.791 218.694 130.334 232.185" />
      </mask>
      <path
        d="M219.481 142.923C226.524 149.939 237.921 149.917 244.937 142.874C251.953 135.831 251.931 124.434 244.888 117.418L219.481 142.923ZM117.63 244.937C124.673 251.953 136.07 251.931 143.086 244.888C150.102 237.845 150.08 226.448 143.037 219.432L117.63 244.937ZM244.888 117.418C227.963 100.559 205.03 91.1088 181.136 91.1413L181.185 127.141C195.545 127.122 209.32 132.801 219.481 142.923L244.888 117.418ZM181.136 91.1413C157.242 91.1739 134.335 100.686 117.456 117.592L142.933 143.027C153.066 132.878 166.826 127.161 181.185 127.141L181.136 91.1413ZM117.456 117.592C100.577 134.499 91.1087 157.415 91.1413 181.301L127.141 181.251C127.122 166.927 132.8 153.177 142.933 143.027L117.456 117.592ZM91.1413 181.301C91.1739 205.186 100.705 228.077 117.63 244.937L143.037 219.432C132.876 209.311 127.161 195.576 127.141 181.251L91.1413 181.301Z"
        fill="#3C3C3C"
        mask="url(#path-5-inside-1)"
      />
      <path
        d="M93.7609 262.945L109.141 247.565"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M386 347.665L338.062 212.337H204.111L156.172 347.665H386Z"
        stroke="#3C3C3C"
        strokeWidth="18"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M242.184 347.665V387.804"
        stroke="#3C3C3C"
        strokeWidth="10"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M300.428 387.804V347.665"
        stroke="#3C3C3C"
        strokeWidth="10"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M271.071 212.337V347.665"
        stroke="#3C3C3C"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M183.916 269.681H358.236"
        stroke="#3C3C3C"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const summer = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="450" height="450" fill="none" />
      <g>
        <circle cx="225" cy="225" r="91.4286" fill="white" />
        <circle cx="225" cy="225" r="82.4286" stroke="#3C3C3C" strokeWidth="18" />
      </g>
      <path
        d="M225 376V345"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225 105V74"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M376 225H345"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M133.284 138.999L111 117"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M105 225H74"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111 321L133.284 299.286"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M316.428 138.999L339 117"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M316.429 299.286L339 321"
        stroke="#3C3C3C"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d"
          x="128.572"
          y="129.571"
          width="194.857"
          height="194.857"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );

  const winter = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 450 450"
      className={className}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M223.443 91V359.843"
          stroke="#3C3C3C"
          strokeWidth="25"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M263.047 106.984L223.443 138.181"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M183.84 106.984L223.443 138.181"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M183.84 347.488L223.443 316.205"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M263.047 347.488L223.443 316.205"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M106.963 158.086L339.916 292.551"
          stroke="#3C3C3C"
          strokeWidth="25"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M140.603 131.873L147.862 181.822"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M101 200.491L147.867 181.824"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M309.391 320.695L302.132 270.832"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M349 252.167L302.132 270.834"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M106.963 294.428L339.916 159.963"
          stroke="#3C3C3C"
          strokeWidth="25"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M101 252.167L147.867 270.834"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M140.603 320.695L147.862 270.832"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M349 200.495L302.132 181.828"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M309.391 131.873L302.132 181.822"
          stroke="#3C3C3C"
          strokeWidth="23"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="84.4968"
          y="74.5"
          width="283.006"
          height="305.843"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="1" dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.188 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );

  const lineGraph = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1875 1875"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1697.28 453.468L826.721 1324.32L579.856 1078.36L168.786 1489.2L101.249 1421.7L579.752 943.471L826.585 1189.4L1629.71 386L1697.28 453.468Z"
        fill="#3C3C3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.491 775.448H97V751.373H111.491V775.448ZM169.457 775.448H140.474V751.373H169.457V775.448ZM227.422 775.448H198.44V751.373H227.422V775.448ZM285.388 775.448H256.405V751.373H285.388V775.448ZM343.353 775.448H314.371V751.373H343.353V775.448ZM401.319 775.448H372.336V751.373H401.319V775.448ZM459.284 775.448H430.302V751.373H459.284V775.448ZM517.25 775.448H488.267V751.373H517.25V775.448ZM575.216 775.448H546.233V751.373H575.216V775.448ZM633.181 775.448H604.198V751.373H633.181V775.448ZM691.147 775.448H662.164V751.373H691.147V775.448ZM749.112 775.448H720.129V751.373H749.112V775.448ZM807.078 775.448H778.095V751.373H807.078V775.448ZM865.043 775.448H836.06V751.373H865.043V775.448ZM923.009 775.448H894.026V751.373H923.009V775.448ZM980.974 775.448H951.991V751.373H980.974V775.448ZM1038.94 775.448H1009.96V751.373H1038.94V775.448ZM1096.91 775.448H1067.92V751.373H1096.91V775.448ZM1154.87 775.448H1125.89V751.373H1154.87V775.448ZM1212.84 775.448H1183.85V751.373H1212.84V775.448ZM1270.8 775.448H1241.82V751.373H1270.8V775.448ZM1328.77 775.448H1299.78V751.373H1328.77V775.448ZM1386.73 775.448H1357.75V751.373H1386.73V775.448ZM1444.7 775.448H1415.72V751.373H1444.7V775.448ZM1502.66 775.448H1473.68V751.373H1502.66V775.448ZM1560.63 775.448H1531.65V751.373H1560.63V775.448ZM1618.59 775.448H1589.61V751.373H1618.59V775.448ZM1676.56 775.448H1647.58V751.373H1676.56V775.448ZM1734.52 775.448H1705.54V751.373H1734.52V775.448ZM1778 775.448H1763.51V751.373H1778V775.448Z"
        fill="#3C3C3C"
      />
    </svg>
  );

  if (type === "cooling") return <div className={className}>{coolingIcon}</div>;
  if (type === "hot-water") return <div className={className}>{hotwaterIcon}</div>;
  if (type === "building") return <div className={className}>{building}</div>;
  if (type === "contact") return <div className={className}>{contact}</div>;
  if (type === "energyCentral") return <div className={className}>{energyCentral}</div>;
  if (type === "energySystem") return <div className={className}>{energySystem}</div>;
  if (type === "heatPump") return <div className={className}>{heatPump}</div>;
  if (type === "pylons") return <div className={className}>{pylons}</div>;
  if (type === "seasonalVariation")
    return <div className={className}>{seasonalVariation}</div>;
  if (type === "solarPanels") return <div className={className}>{solarPanels}</div>;
  if (type === "summer") return <div className={className}>{summer}</div>;
  if (type === "winter") return <div className={className}>{winter}</div>;
  if (type === "lineGraph") return <div className={className}>{lineGraph}</div>;
  if (type === "noData") return <div className={className}>{noData}</div>;

  return null;
};

export default Icon;
